import * as auth from './auth';
import * as geolocation from './geolocation';

export const api = {
  auth,
  geolocation,
};
